import React, { FC } from 'react'

import Success from './Success'
import Spinner from './Spinner'
import { PlaidLink } from '../PlaidLink'
import { usePlaid } from './PlaidContext'
import { cn } from '@mortgage-pos/ui/utils/cn'
import { LoanPurpose } from '@mortgage-pos/types'
import Button, { ButtonVariants } from '../Button'
import { useStoreState } from '@mortgage-pos/ui/store'
import PaperJet from '@mortgage-pos/ui/assets/paper-jet.svg'

const PlaidConnect: FC = () => {
  const { setUsePlaidUpload, plaidModalOpen } = usePlaid()
  const { loanPurpose } = useStoreState((state) => state.answers.answers)
  const { accounts, isLoading } = useStoreState((state) => state.plaid)

  const backClickHandler = () => {
    setUsePlaidUpload(undefined)
  }

  if (accounts && accounts.length > 0) {
    return <Success />
  }

  const secondBulletCopy =
    loanPurpose === LoanPurpose.Purchase
      ? 'Accounts holding funds for down payment and closing costs.'
      : 'Accounts holding funds for closing costs.'

  return (
    <div
      className={cn('plaid-assets__content', {
        'plaid-assets__hidden': plaidModalOpen,
      })}
    >
      <div className="plaid-assets__logo">
        <img src={PaperJet} alt="PaperJet" height={44} />
      </div>
      <div className="plaid-assets__header">
        <p className="plaid-assets__title">Before you go</p>
        <p className="plaid-assets__heading">Which accounts do I connect?</p>
        <p className="plaid-assets__subtitle">
          You will need to link the following:
        </p>
        <ul className="plaid-assets__bullets">
          <li className="plaid-assets__bullet-item">
            <b>ALL</b> accounts where direct deposits (e.g., paychecks) are
            received.
          </li>
          <li className="plaid-assets__bullet-item">{secondBulletCopy}</li>
        </ul>
      </div>

      {isLoading && <Spinner />}

      <PlaidLink
        content="Continue to Plaid"
        btnClassName="plaid-assets__cta-start-plaid"
      />

      <Button
        disabled={isLoading}
        className="plaid-assets__cta-link plaid-assets__mt-24"
        onClick={backClickHandler}
        variant={ButtonVariants.default}
        content="< Back"
      />
    </div>
  )
}

export default PlaidConnect
